import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserDataFragmentDoc } from '../../../../../graphql/fragments/generated/UserData';
export type MeetingInstanceLiteFragment = { id: string, type: Types.MeetingInstanceTypeEnum, meetingId: string, rootBlockId?: string | null, status: Types.PublicMeetingInstanceStatusEnum, startTime: string, actualEndTime?: string | null, actualStartTime?: string | null, organizerId: string, actionItemsCount: number, agendaItemsCount: number, occurrenceType: Types.MeetingInstanceOccurrenceTypeEnum, updatedAt: string, participantsProfile?: Array<{ id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null }> | null, summary?: { text?: string | null, status: Types.MeetingInstanceSummaryStatusEnum } | null };


export type MeetingInstanceLiteFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MeetingInstanceLiteFragmentDoc = /*#__PURE__*/ gql`
    fragment MeetingInstanceLite on MeetingInstanceType {
  id
  type
  meetingId
  rootBlockId
  status
  participantsProfile {
    ...UserData
  }
  startTime
  actualEndTime
  actualStartTime
  organizerId
  actionItemsCount
  agendaItemsCount
  occurrenceType
  updatedAt
  summary {
    text
    status
  }
}
    `;